<template>
  <div class="move-footer">
    <div class="footer-nav">
      <dl>
        <dt>Help & Support</dt>
        <dd>
          <a href="https://support.movingkite.com/hc/en-us/articles/4404704275611" target="_blank">Packing Advice</a>
        </dd>
        <dd>
          <a href="https://support.movingkite.com/hc/en-us/articles/4404707626779" target="_blank"
            >About FedEx Pick-up</a
          >
        </dd>
        <dd>
          <a href="https://support.movingkite.com/hc/en-us/articles/4404707496475" target="_blank"
            >Prohibited articles</a
          >
        </dd>
      </dl>
      <dl>
        <dt>Contact us</dt>
        <dd><a href="mailto:support@movingkite.com" target="_blank">support@movingkite.com</a></dd>
        <dd><a>(945) 667-2285</a></dd>
      </dl>
    </div>
    <div class="footer-privacy">
      <ul>
        <li>
          <a href="https://support.movingkite.com/hc/en-us/articles/4408785752347" target="_blank">Privacy Policy</a>
        </li>
        <li>
          <a href="https://support.movingkite.com/hc/en-us/articles/4408794119451" target="_blank">Terms of Service</a>
        </li>
        <li>
          <a href="https://support.movingkite.com/hc/en-us/articles/5926592731419" target="_blank">Insurance Policy</a>
        </li>
        <li>
          <a href="https://support.movingkite.com/hc/en-us/articles/5924798828059" target="_blank">Terms of Pay</a>
        </li>
      </ul>
      <p class="footer-flag">
        <a>© {{ currentYear }} MOVINGKITE. All Rights Reserved</a>
      </p>
    </div>
    <div class="footer-logo">
      <img src="../../assets/imgs/logo.png" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'MoveFooter',
  data() {
    return {
      currentYear: new Date().getFullYear(),
    };
  },
  methods: {
    newWindow(url) {
      window.open(url, '_blank');
    },
  },
};
</script>

<style lang="less">
@import '../../assets/fonts/font.less';
@import '../../assets/css/main.less';
.move-footer {
  height: 287px;
  padding: 0 106px;
  position: relative;
  background-color: #f7f8fc;
  a {
    cursor: pointer;
  }
  .footer-nav {
    padding-top: 45px;
    overflow: hidden;
    dl {
      float: left;
      line-height: 32px;
      &:last-child {
        margin-left: 90px;
      }
      dt {
        .font-medium;
        font-size: 14px;
        font-weight: 500;
        color: @app-black-color;
      }
      a {
        .font-light;
        font-size: 14px;
        font-weight: 300;
        color: @app-body-color;
      }
    }
  }
  .footer-privacy {
    ul {
      margin-top: 30px;
      overflow: hidden;
      li {
        float: left;
        margin-right: 30px;
        a {
          .font-light;
          font-size: 14px;
          font-weight: 300;
          color: @app-body-color;
          line-height: 18px;
        }
      }
    }
    .footer-flag {
      .font-light;
      margin-top: 16px;
      font-size: 14px;
      font-weight: 300;
      line-height: 18px;
      a {
        color: @app-body-color;
      }
    }
  }
  .footer-logo {
    position: absolute;
    bottom: 40px;
    right: 106px;
    img {
      width: 150px;
    }
  }
}
</style>
